import React from 'react';
import { Icon } from '@iconify/react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PaymentCancel = () => {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        padding: '40px',
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)'
      }}>
        {/* Icône d'annulation */}
        <div style={{
          width: '100px',
          height: '100px',
          borderRadius: '50%',
          backgroundColor: '#fff3cd',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          border: '4px solid #ffc107'
        }}>
          <Icon 
            icon="material-symbols:cancel" 
            style={{ 
              fontSize: '48px', 
              color: '#ffc107' 
            }} 
          />
        </div>

        {/* Titre */}
        <h1 style={{
          color: '#856404',
          fontSize: '32px',
          fontWeight: 'bold',
          marginBottom: '20px'
        }}>
          {t('subscription.payment.cancelPage.title')}
        </h1>

        {/* Message */}
        <p style={{
          fontSize: '18px',
          color: '#666',
          marginBottom: '30px',
          lineHeight: '1.6'
        }}>
          {t('subscription.payment.cancelPage.text')}
        </p>

        {/* Informations supplémentaires */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '20px',
          borderRadius: '10px',
          marginBottom: '30px',
          textAlign: 'left'
        }}>
          <h3 style={{ color: '#333', marginBottom: '15px', fontSize: '18px' }}>
            {t('subscription.payment.cancelPage.whatHappened')}
          </h3>
          <ul style={{ 
            margin: 0, 
            paddingLeft: '20px', 
            color: '#666',
            lineHeight: '1.6'
          }}>
            <li>{t('subscription.payment.cancelPage.reasons.0')}</li>
            <li>{t('subscription.payment.cancelPage.reasons.1')}</li>
            <li>{t('subscription.payment.cancelPage.reasons.2')}</li>
          </ul>
        </div>

        {/* Boutons d'action */}
        <div style={{
          display: 'flex',
          gap: '20px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={() => window.location.href = '/'}
            style={{
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '25px',
              padding: '12px 30px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
          >
            <Icon icon="material-symbols:home" />
            {t('subscription.payment.cancelPage.home')}
          </button>

          <button
            onClick={() => window.history.back()}
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '25px',
              padding: '12px 30px',
              fontSize: '16px',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0056b3'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#007bff'}
          >
            <Icon icon="material-symbols:refresh" />
            {t('subscription.payment.cancelPage.retry')}
          </button>
        </div>

        {/* Informations de contact */}
        <div style={{
          marginTop: '40px',
          padding: '20px',
          backgroundColor: '#e9ecef',
          borderRadius: '10px',
          fontSize: '14px',
          color: '#666'
        }}>
          <p style={{ margin: 0, marginBottom: '10px' }}>
            <Icon icon="material-symbols:info" style={{ marginRight: '8px' }} />
            <strong>{t('subscription.payment.cancelPage.needHelp')}</strong>
          </p>
          <p style={{ margin: 0 }}>
            {t('subscription.payment.cancelPage.contact')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
